import { render, staticRenderFns } from "./introduce.vue?vue&type=template&id=6a2c4fdc&"
import script from "./introduce.vue?vue&type=script&lang=js&"
export * from "./introduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports